export enum CandidateApplicationState {
  PENDING = "PENDING",
  IN_PROCESS = "IN_PROCESS",
  APPROVED = "APPROVED",
  MIGRATED = "MIGRATED",
  DISAPPROVED = "DISAPPROVED",
  DROPPED = "DROPPED",
  ABSENT = "ABSENT",
}
